import styled from 'styled-components';
import { StyledLinkBranded } from 'elements/links/Link.branded.styles';
import { palette } from 'styles/colors';

export const StyledLinkPro = styled(StyledLinkBranded)`
  color: ${palette.white};
  background-color: ${palette.proBlue};
`;
